// import { useRoutePath } from '@daysmart/daysmart-vue-components/composables'

export function useIsRouteResolved() {
  // TODO: refactor this
  // const { routePath, isRouterPath } = useRoutePath()
  // const isRouteResolved = computed(() => route.value && route.value !== '/')
  // if (isRouterPath) {
  //   const isRouteResolved = computed(() => {
  //     routePath.value && routePath.value === window.location.pathname
  //   })
  // }
  const isRouteResolved = ref(true)
  return { isRouteResolved }
}
